import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Settings as SettingsIcon, Save } from 'lucide-react'
import toast from 'react-hot-toast'

const Settings: React.FC = () => {
  const { t, i18n } = useTranslation()
  const [settings, setSettings] = useState({
    language: i18n.language,
    emailNotifications: true,
    darkMode: true
  })

  const handleSave = () => {
    i18n.changeLanguage(settings.language)
    localStorage.setItem('userSettings', JSON.stringify(settings))
    toast.success(t('settings.saveSuccess'))
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-white mb-2">{t('settings.title')}</h1>
        <p className="text-gray-400">{t('settings.subtitle')}</p>
      </div>

      <div className="bg-dark-800 rounded-lg p-6 border border-dark-700">
        <h2 className="text-xl font-semibold text-white mb-4 flex items-center">
          <SettingsIcon className="h-5 w-5 text-primary mr-2" />
          {t('settings.applicationSettings')}
        </h2>

        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              {t('settings.language')}
            </label>
            <select
              value={settings.language}
              onChange={(e) => setSettings(prev => ({ ...prev, language: e.target.value }))}
              className="w-full max-w-xs px-3 py-2 bg-dark-700 border border-dark-500 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-primary"
            >
              <option value="pl">Polski</option>
              <option value="en">English</option>
              <option value="de">Deutsch</option>
              <option value="es">Español</option>
            </select>
          </div>

          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-white font-medium">{t('settings.emailNotifications')}</h3>
              <p className="text-sm text-gray-400">{t('settings.emailNotificationsDescription')}</p>
            </div>
            <input
              type="checkbox"
              checked={settings.emailNotifications}
              onChange={(e) => setSettings(prev => ({ ...prev, emailNotifications: e.target.checked }))}
              className="h-4 w-4 text-primary focus:ring-primary border-dark-500 rounded bg-dark-700"
            />
          </div>

          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-white font-medium">{t('settings.darkMode')}</h3>
              <p className="text-sm text-gray-400">{t('settings.darkModeDescription')}</p>
            </div>
            <input
              type="checkbox"
              checked={settings.darkMode}
              onChange={(e) => setSettings(prev => ({ ...prev, darkMode: e.target.checked }))}
              className="h-4 w-4 text-primary focus:ring-primary border-dark-500 rounded bg-dark-700"
            />
          </div>

          <button
            onClick={handleSave}
            className="flex items-center space-x-2 px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90"
          >
            <Save className="h-4 w-4" />
            <span>{t('settings.save')}</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default Settings